import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageNotFoundModuleRoutingModule } from './page-not-found-module-routing.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ComponentsModule } from 'app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PageNotFoundModuleRoutingModule
  ],
  declarations: [PageNotFoundComponent]
})
export class PageNotFoundModule { }



// WEBPACK FOOTER //
// ./src/app/pages/page-not-found-module/page-not-found-module.module.ts